module.exports = __webpack_public_path__ + "img/50.614b13c1.png";